// Backup codes: ten codes of ten characters, shown as XXXXX-XXXXX. Upper
// case and digits only, without the look-alikes (0/O, 1/I/L), so a code
// copied onto paper reads back the same.
export const BACKUP_CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
export const BACKUP_CODE_COUNT = 10;

/** One code from ten random numbers (each picks a letter of the alphabet). */
export function formatBackupCode(picks: number[]): string {
  const s = picks.map((n) => BACKUP_CODE_ALPHABET[n % BACKUP_CODE_ALPHABET.length]).join("");
  return `${s.slice(0, 5)}-${s.slice(5, 10)}`;
}

/**
 * What a typed backup code may have been meant as, most likely first:
 * full-width characters, spaces and dashes are tidied and the dash put
 * back in place. Codes made before 2026-10-22 mix upper and lower case,
 * so the case as typed is tried first and upper case second.
 */
export function backupCodeCandidates(typed: string): string[] {
  const plain = typed
    .normalize("NFKC")
    .replace(/[\s\u2010-\u2015\u2212\u30fc\uff70-]/g, "");
  if (!plain) return [];
  const dashed = (s: string) => (s.length === 10 ? `${s.slice(0, 5)}-${s.slice(5)}` : s);
  return [...new Set([dashed(plain), dashed(plain.toUpperCase())])];
}
